import {Cards} from "../../Product/Card/Cards";

export let ProductSliderProps = {
    title: {
        default: ''
    },
    productCategories: {
        type: Object,
        default: null
    },
    productBrands: {
        type: Object,
        default: null
    },
    waitForCategory: {
        type: Boolean,
        default: false
    },
    waitForBrand: {
        type: Boolean,
        default: false
    },
    categoryColumn: {
        type: String,
        default: 'slug'
    },
    brandColumn: {
        type: String,
        default: 'slug'
    },
    productCardLink: {
        type: Boolean,
        default: false
    },
    productCardLinkTarget: {
        options: ['_self', '_blank'],
        default: '_self'
    },
    activeLatestFilter: {
        type: Boolean,
        default: true,
    },
    activeCategoryFilter: {
        type: Boolean,
        default: true
    },
    productCardName: {
        options: Object.keys(Cards),
        default: 'mProductCard309',
    },
    showKeywords: {
        type: Boolean,
        default: false
    },
    showDefaultSlideItem:{
        type: Boolean,
        default: false
    },
    swiperPerViewSM: {
        type: Number,
        default: 2,
    },
    swiperPerViewMD: {
        type: Number,
        default: 3,
    },
    swiperPerViewLG: {
        type: Number,
        default: 4,
    },
    autoPlay: {
        type: Boolean,
        default: false,
    },
    autoPlayDuration: {
        default: 1000,
    },
}